import React, { useEffect } from "react";
import { publicSeoHubs } from "@/lib/publicSeoHubs";
import { getLocalizedSeoHub, getSeoHubLabels } from "@/i18n";
import { useParams } from "react-router-dom";
import PublicSeoHero from "@/components/public-seo/PublicSeoHero";
import PublicSeoSections from "@/components/public-seo/PublicSeoSections";
import PublicSeoFaq from "@/components/public-seo/PublicSeoFaq";
import PublicSeoRelated from "@/components/public-seo/PublicSeoRelated";
import PublicSeoDetailLinks from "@/components/public-seo/PublicSeoDetailLinks";
import GlossaryAutocomplete from "@/components/public-seo/GlossaryAutocomplete";
import RegulationsExplorer from "@/components/public-seo/RegulationsExplorer";
import PublicAdPlaceholder from "@/components/public/PublicAdPlaceholder";
import PublicBreadcrumbs from "@/components/public/PublicBreadcrumbs";

export default function PublicSeoHub({ type }) {
  const { lang = "en" } = useParams();
  const hub = getLocalizedSeoHub(type, lang, publicSeoHubs[type] || publicSeoHubs.routes);
  const labels = getSeoHubLabels(type, lang);
  const showBreadcrumbs = ["glossary", "regulations"].includes(type);
  const breadcrumbItems = showBreadcrumbs
    ? [
        { label: labels.home, href: `/${lang}` },
        { label: labels.breadcrumb },
      ]
    : [];

  useEffect(() => {
    const path = window.location.pathname;
    const url = `https://marstick.com${path}`;
    const schema = document.createElement("script");
    schema.type = "application/ld+json";
    schema.id = `schema-${type}-hub`;
    schema.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@type": hub.schemaType,
      name: hub.title,
      description: hub.description,
      url,
      mainEntity: hub.faqs.map((faq) => ({
        "@type": "Question",
        name: faq.question,
        acceptedAnswer: { "@type": "Answer", text: faq.answer },
      })),
    });
    document.head.appendChild(schema);
    return () => schema.remove();
  }, [hub, type]);

  return (
    <main className="maritime-page-shell">
      {showBreadcrumbs && <PublicBreadcrumbs items={breadcrumbItems} />}
      <PublicSeoHero hub={hub} premiumLabel={labels.premiumTools} />
      <PublicAdPlaceholder />
      {type === "regulations" && <RegulationsExplorer links={hub.featuredPages || []} lang={lang} />}
      <PublicSeoSections sections={hub.sections} />
      {type === "glossary" && <GlossaryAutocomplete lang={lang} />}
      {type !== "regulations" && (
        <PublicSeoDetailLinks title={labels.featuredTitle} links={hub.featuredPages || []} hideLabel={['glossary', 'regulations'].includes(type)} />
      )}
      <PublicSeoFaq faqs={hub.faqs} title={labels.faqTitle} />
      {!['glossary', 'regulations'].includes(type) && <PublicSeoRelated links={hub.related} />}
    </main>
  );
}